import { CryptobadgeClient } from "@vingle/cryptobadge-sdk";

function getCryptoBadgeAPIDomain() {
  return `https://dev.api.cryptobadge.xyz/m1/api`;
}

export const CryptoBadgeClient = new CryptobadgeClient({
  url: getCryptoBadgeAPIDomain(),
  accessToken: "58qxzRGlNre0SgV76LRGNZ4FjO1T",
  authorizationKey: "lCY/MgfbG/xaghiJHuMtW8cypgSVBHfZlyMOFwlBmzo=",
});

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class CryptoBadgeAPI {
  public static async getUserCryptoBadgeCertificates(params: {
    userId: string;
    issuers?: string[];
    issuer?: string;
  }) {
    return (
      await CryptoBadgeClient.getCertificates({
        userId: params.userId,
        issuers: params.issuers,
        issuer: params.issuer,
      })
    ).data;
  }

  public static async getCertificateItems(params: {
    issuers: string[];
    name?: string;
  }) {
    return (
      await CryptoBadgeClient.getCertificates({
        issuers: params.issuers,
        name: params.name,
      })
    ).data;
  }

  public static async getBadgeItems(params: { name: string }) {
    return (
      await CryptoBadgeClient.getBadges({
        name: params.name,
      })
    ).data;
  }

  public static async getBadgeItem(params: { id: string }) {
    return (await CryptoBadgeClient.getBadge(params)).data;
  }

  public static async getCertificateItem(params: { id: string }) {
    return (await CryptoBadgeClient.getCertificate(params)).data;
  }

  public static async getMintRequests(params: {
    issuers: string[];
    count?: number;
    after?: string;
  }) {
    return (
      await CryptoBadgeClient.getBadgeMintRequests({
        issuers: params.issuers,
        first: params.count,
        after: params.after,
      })
    ).data;
  }

  public static async refreshBadgeMetadata(params: { badgeRefreshId: string }) {
    return (
      await CryptoBadgeClient.refreshBadgeMetadata({
        badgeRefreshId: params.badgeRefreshId,
      })
    ).data;
  }
}
